import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Icon from 'components/Icon'
import DropdownInput from 'components/DropdownInput'
import Button from 'components/Button'
import CheckboxGroup from 'components/CheckboxGroup'
import { Waypoint } from 'react-waypoint'
import messages from './messages'
import styles from './FilterableList.scss'

const reviewsStub = [
  {
    reviewDate: '01/07/2019',
    reviewRating: 5,
    reviewSource: 'gmaps',
    reviewText:
      'La atención telefónica que tuve por parte de Rodrigo fue excelente. Me explicó todo lo referente a la página web y a la figura de delegado de protección de datos punto por punto con infinita paciencia. Pude consultarle alguna duda que tenía y me lo aclaró todo totalmente. La empresa es recomendable cien por cien. El personal es muy amable. Un acierto haber dado con ellos.',
    reviewTextTranslated:
      'The telephone service I had on behalf of Rodrigo was excellent. He explained everything about the web page and the figure of data protection delegate point by point with infinite patience. I was able to ask him any questions he had and he explained everything to me completely. The company is recommended one hundred percent. The personnel is very friendly. A success to have found with them.',
    reviewUrl:
      'https://www.google.com/maps/reviews/data=!4m5!14m4!1m3!1m2!1s102208980443880684071!2s0x0:0xa82fbe40ca5ebd3?hl=en-IL',
    userName: 'Patricio Oribe Muguruza',
    userPhoto:
      'https://lh5.googleusercontent.com/-BoNUhu4ALC8/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucmXc-GsD7eVeCfxMl3u0eiW1NrgKA/c0x00000000-cc-rp/photo.jpg',
  },
  {
    reviewDate: '13/01/2020',
    reviewRating: 5,
    reviewSource: 'gmaps',
    reviewText:
      'Una empesa 10!! Tanto Ana, como Rodrigo como Idoia super amables, nos han gestionado todo en 48 horas, los volvería a contratar sin duda!!',
    reviewTextTranslated:
      'A back gray 10 !! Both Ana and Rodrigo as Idoia super friendly, we have managed everything within 48 hours, the contract would definitely !!',
    reviewUrl:
      'https://www.google.com/maps/reviews/data=!4m5!14m4!1m3!1m2!1s107077600891494336370!2s0x0:0xa82fbe40ca5ebd3?hl=en-IL',
    userName: 'Asier Arriba',
    userPhoto: 'https://lh3.googleusercontent.com/a-/AOh14GjC4pAYHWPe1h08w2BzE_2haF_Mx59UxynxL4Siww=c0x00000000-cc-rp',
  },
  {
    reviewDate: '23/01/2020',
    reviewRating: 5,
    reviewSource: 'gmaps',
    reviewText:
      'Trato excelente, de 10. Muy amables, profesionales, atentos. La explicación de Rodrigo excelente. para recomendar',
    reviewTextTranslated:
      'Excellent treatment, 10. Very friendly, professional, attentive. Rodrigo excellent explanation. to recommend',
    reviewUrl:
      'https://www.google.com/maps/reviews/data=!4m5!14m4!1m3!1m2!1s118162308590962216029!2s0x0:0xa82fbe40ca5ebd3?hl=en-IL',
    userName: 'MERCHE GARCIA',
    userPhoto:
      'https://lh3.googleusercontent.com/-I-6cUipam44/AAAAAAAAAAI/AAAAAAAAAAA/AMZuucl5v9vIcbpMvWbby9Un7hbgdrozGA/c0x00000000-cc-rp/photo.jpg',
  },
  {
    projectEndDate: '2019-06-22T00:00:00.000Z',
    projectStartDate: '2019-06-14T00:00:00.000Z',
    reviewDate: '2019-06-22T00:00:00.000Z',
    reviewRating: 4.85,
    reviewSource: 'upwork',
    reviewText:
      'Roberto is an excellent programmer, his attention to detail is second-to-none and he is a pleasure to work with. He will attend daily stand-ups, implement new ideas & help your company progress greatly!',
    reviewTitle: 'On-Going iOS Work',
    totalCharges: 375,
    userName: '5743610',
  },
  {
    projectEndDate: '2015-11-16T00:00:00.000Z',
    projectStartDate: '2015-10-01T00:00:00.000Z',
    reviewDate: '2015-11-16T00:00:00.000Z',
    reviewRating: 5,
    reviewSource: 'upwork',
    reviewText: 'top drawer contractor A++ experience.',
    reviewTitle: 'WebGL Developer',
    totalCharges: 1930,
    userName: '736419',
  },
  {
    projectEndDate: '2015-11-16T00:00:00.000Z',
    projectStartDate: '2015-10-01T00:00:00.000Z',
    reviewDate: '2015-11-16T00:00:00.000Z',
    reviewRating: 5,
    reviewSource: 'upwork',
    reviewText: 'top drawer contractor B++ experience.',
    reviewTitle: 'WebGL Developer',
    totalCharges: 1930,
    userName: '736419',
  },
  {
    projectStartDate: '2019-10-16T00:00:00.000Z',
    reviewSource: 'upwork',
    reviewTitle: 'Urgent MFMailComposeViewController fix needed for Xcode 11 update',
    totalCharges: 237.5,
    userName: '5567265',
  },
  {
    reviewText:
      'Very nice guys. Did very professional job painting wall and installing lights. Will definitely order their service again when needed.',
    reviewRating: 5,
    reviewSource: 'houzz',
    subjectType: 'PROFESSIONAL',
    relationship: 'CLIENT',
    projectDate: '2019-05-01',
    projectPriceAsString: '$1,000 - $9,999',
    priceMin: 1000,
    priceMax: 9999,
    status: 'ACTIVE',
  },
  {
    userName: 'Julie B.',
    userLocation: 'Brooklyn, NY',
    userPhoto: 'https://s3-media0.fl.yelpcdn.com/photo/bhKa_tRJmE9qao90P48S8Q/60s.jpg',
    reviewText:
      'Called after reading great reviews on Yelp. It&#39;s always nerve wracking working with a contractor as some are so unreliable. But Vlad and his team are simply amazing. He&#39;s so patient as my co-op board was very strict on working during the pandemic. His crew was on time if not early everyday to work. They are also very clean and tried to keep dust to a minimum. They remodeled my entire en-suite bathroom. I&#39;m thrilled with the results. I will definitely be calling them for more projects.',
    reviewRating: 5,
    reviewDate: '8/2/2020',
    reviewSource: 'yelp',
  },
  {
    reviewText:
      "\n\nNowadays the amount of construction companies is probably as big as the amount of restaurants. When you are choosing a restaurant for dinner, you never know that you gonna like there. There is the same situation with construction companies. You never know how reliable they are, but general contractor Modern Citi Group is definitely  “the best restaurant” in the construction business!\nWe’ve hired licensed contractor Daniil for our home remodeling in Staten Island a few month ago. He is full of integrity, he’s honest, punctual, and is creatively competent. Moreover, residential contractor Modern Citi Group team genuinely appreciates their costumers. They are going out of their way to make sure your project is completed to your satisfaction, and that is why I recommended to work with them as your residential general contractor in NYC! \nOur home is 27 years old and this was our first major bathroom and kitchen remodel. All staff from renovation contractor Modern Citi Group were very knowledgeable and made the whole process go smoothly. Modern Cit Group design crew took our old looking bathrooms and made them look like a luxury hotel bathrooms complete with all the beautiful amenities: custom tile, jacuzzi, steam shower, new toilets all beautifully and perfectly installed by Modern Citi Group team. We had issue with our wood floor as it was squeaking in certain parts of the living room and kitchen area. We also had a leak under our sink and the floor and the cabinets where all damaged and moldy. We explained to project designers our wishes and issues. They helped us design the kitchen area and made a visual representation of it so we can see which was really great. Modern Citi Group have done with new tile floor in the kitchen and wood floor in living room area, finished wall painting and installed new modern custom kitchen cabinets with marble countertop. Further, they took our girls 10' x 10' x 16'h room and completed update it by all finishing works. \nYou will be in really good hands hiring these guys. Got super lucky and found them on Yelp.\n\n\nRead more\n",
    reviewRating: 5,
    reviewSource: 'buildzoom',
    userName: 'Julia A.',
    reviewDate: 'June 4, 2020',
    value: 100000,
    reviewBuildingType: 'General Contractor - Remodeling',
  },
  {
    reviewText:
      "These guys are seriously the Mercedes Benz of Kitchens. If you're looking for kitchen remodeling contractor in Brooklyn to make the kitchen of your dreams pick up the phone and call Modern Citi Group.\r\nWe had plans of remodeling our kitchen with new granite countertops and backsplash. So, we did some researching on companies in our local area that we would feel comfortable with. I’m so glad to found residential general Contractor Daniil from Modern Citi Group for our kitchen remodel project. After meeting with the design team, they quickly turned our boring kitchen into the vision we had wanted for quite some time.We know from past experience that when it comes to construction or home remodeling it's best not to look for bargains. Too many things can go wrong when dealing with the wrong people. It can end up costing even more money to have it redone properly not to even mention all the aggravation.\r\n\r\nDaniil is the best licensed contractor we’ve ever used. We couldn't be happier with the results and will definitely hire Daniil as a home remodeling contractor and Modern Citi Group team again for  our renovation projects!",
    reviewRating: 5,
    reviewSource: 'houzz',
    subjectType: 'PROFESSIONAL',
    relationship: 'CLIENT',
    projectDate: '2020-04-01',
    projectPriceAsString: '$10,000 - $49,999',
    priceMin: 10000,
    priceMax: 49999,
    status: 'ACTIVE',
  },
]
const reviewsStub2 = [
  {
    reviewSource: 'etsy',
    eventDate: '18/2/2021',
    reviewTitle: 'Hand Stamped Mini Initial Sterling Silver Squirrel Charm Necklace',
    userName: 'Kristin Gray',
    userPhoto: 'https://i.etsystatic.com/iusa/3d4696/76736265/iusa_75x75.76736265_q5qn.jpg?version=0',
    cost: 37.4,
    reviewPhoto: 'https://i.etsystatic.com/6047537/r/il/a188d6/492168683/il_794xN.492168683_a24j.jpg',
  },
  {
    reviewSource: 'etsy',
    eventDate: '28/1/2021',
    reviewTitle: 'Sterling Silver Angel Wing Charm Necklace with Mini Hand Stamped Initial and Birthstone',
    userName: 'Chasey Mays',
    userPhoto: 'https://i.etsystatic.com/iusa/610361/70067542/iusa_75x75.70067542_cv59.jpg?version=0',
    cost: 34,
    reviewPhoto: 'https://i.etsystatic.com/6047537/r/il/b17baa/504283671/il_794xN.504283671_sww3.jpg',
  },
  {
    reviewSource: 'etsy',
    eventDate: '18/11/2020',
    reviewTitle: "Dog Nose Print Impression Necklace - from your ACTUAL dog's nose",
    userName: 'lilliancarnes',
    userPhoto: 'https://i.etsystatic.com/iusa/3395e2/72834868/iusa_400x400.72834868_ig0j.jpg?version=0',
    cost: 89,
    reviewPhoto: 'https://i.etsystatic.com/6047537/r/il/eb4e46/433789580/il_794xN.433789580_h0pe.jpg',
  },
  {
    reviewSource: 'etsy',
    eventDate: '2/11/2020',
    reviewTitle: "Dog Paw and Fingerprint Necklace made from your Dog's Actual Paw Print and Your Actual Fingerprint",
    userName: 'Emily',
    userPhoto: 'https://i.etsystatic.com/iusa/74c691/83628384/iusa_75x75.83628384_hy5o.jpg?version=0',
    cost: 110,
    reviewPhoto: 'https://i.etsystatic.com/6047537/r/il/0c338e/443821009/il_794xN.443821009_8rhi.jpg',
  },
]

function FilterableList(props) {
  const {
    items = [],
    filterKey,
    filterOptions,
    filterSelections = [],
    onFilter = () => {},
    renderItem,
    onScroll = () => {},
    numberOfTotalItems = 0,
    numberOfDocumentedItems = 0,
  } = props

  const FilterButton = () => (
    <Button buttonType='icon' outline={!filterSelections.length} className={styles.filterButton}>
      <Icon name='filters' size='regular' />
    </Button>
  )

  const displayedItems = items

  const getNumberOfItemsByType = () => ({
    review: numberOfTotalItems,
    coin: numberOfDocumentedItems,
  })

  const headers = getNumberOfItemsByType()

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h3 className={styles.summary}>
          <div className={styles.actions}>
            <DropdownInput
              disableSearch
              hasSelectAll
              options={filterOptions}
              selections={filterSelections}
              onChange={onFilter}
              buttonRenderer={FilterButton}
              className={styles.filter}
            />
          </div>
          <div className={styles.title}>
            <FormattedMessage {...messages.documentedActivity} values={{ count: numberOfTotalItems }} tagName='span' />
          </div>
          <div className={styles.numbers}>
            <CheckboxGroup
              type='regular'
              isRow
              withIcons
              name='activityFilter'
              options={Object.keys(headers).map(key => `${key}`)}
              customValues={[`Documented Activity (${headers.review})`, `Documented Revenue (${headers.coin})`]}
              selections={[]}
              onChange={option => {}}
            />
          </div>
        </h3>
      </header>
      <ul className={styles.items}>
        {displayedItems.map((item, index) => (
          <li key={index} className={styles.item}>
            {renderItem(item)}
            {index === displayedItems.length - 4 && <Waypoint onEnter={onScroll} />}
          </li>
        ))}
      </ul>
    </div>
  )
}

FilterableList.propTypes = {
  items: PropTypes.any,
  filterKey: PropTypes.string.isRequired,
  filterOptions: PropTypes.any, //PropTypes.arrayOf(DropdownItemPropType).isRequired,
  filterSelections: PropTypes.any, //PropTypes.arrayOf(DropdownItemPropType),
  onFilter: PropTypes.func,
  renderItem: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  numberOfTotalItems: PropTypes.number,
  numberOfDocumentedItems: PropTypes.number,
}

export default FilterableList
